import { createRouter, createWebHistory } from 'vue-router'

import { authGuard, adminGuard } from '@/router/guards'
import { getCurrentUser } from "@/utilities/token";
import AuthApi from '@/api/auth'
import MainLayout from '@/layouts/MainLayout.vue'

// Auth
import LoginView from '@/views/Auth/LoginView.vue'
import RegisterView from '@/views/Auth/RegisterView.vue'
import ForgotPasswordView from '@/views/Auth/ForgotPasswordView.vue'
import ResetPasswordView from '@/views/Auth/ResetPasswordView.vue'
import ConfirmAccountView from '@/views/Auth/ConfirmAccountView.vue'
import UnlockAccountView from '@/views/Auth/UnlockAccountView.vue'

// Reports
import ReportsView from '@/views/ReportsView/ReportsView.vue'
import NewReportView from '@/views/NewReportView/NewReportView.vue'
import ReportDetailView from '@/views/ReportDetailsView/ReportDetailsView.vue'

// Admin
import DashboardView from '@/views/DashboardView/DashboardView.vue'
import ManageUsersView from '@/views/ManageUsersView/ManageUsersView.vue'
import UserDetailsView from '@/views/UserDetailsView/UserDetailsView.vue'
import PricingCatalogView from '@/views/PricingCatalogView/PricingCatalogView.vue'
import PromptsView from '@/views/PromptsView/PromptsView.vue'
import DocumentsView from '@/views/DocumentsView/DocumentsView.vue'

// Misc
import NotFoundView from '@/views/NotFoundView/NotFoundView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView,
    beforeEnter: async () => {
      await AuthApi.logout()
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView,
    beforeEnter: async () => {
      await AuthApi.logout()
    }
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: ConfirmAccountView,
    beforeEnter: async (to) => {
      if (!to.query.confirmation_token) {
        return { name: 'login' }
      } else {
        await AuthApi.logout()
      }
    }
  },
  {
    path: '/unlock-account',
    name: 'unlock-account',
    component: UnlockAccountView,
    beforeEnter: async () => {
      await AuthApi.logout()
    }
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: async () => {
      await AuthApi.logout()
      return { name: 'login' }
    }
  },
  {
    path: '/',
    component: MainLayout,
    redirect: () => {
      const currentUser = getCurrentUser();
      return currentUser?.role === 'admin' ? 'admin' : 'reports';
    },
    meta: { requiresAuth: true },
    children: [
      {
        path: 'reports',
        children: [
          {
            path: '',
            name: 'reports',
            component: ReportsView
          },
          {
            path: 'new',
            name: 'new-report',
            component: NewReportView
          },
          {
            path: ':id',
            name: 'report-details',
            component: ReportDetailView
          }
        ]
      },
      {
        path: 'admin',
        meta: { requiresAdmin: true },
        children: [
          {
            path: '',
            name: 'dashboard',
            component: DashboardView,
          },
          {
            path: 'users',
            name: 'manage-users',
            component: ManageUsersView,
          },
          {
            path: 'pricing',
            name: 'pricing-catalog',
            component: PricingCatalogView,
          },
          {
            path: 'prompts',
            name: 'prompts',
            component: PromptsView,
          },
          {
            path: 'documents',
            name: 'documents',
            component: DocumentsView,
          },
          {
            path: ':id',
            name: 'user-details',
            component: UserDetailsView,
          }
        ]
      },
      {
        path: ':pathMatch(.*)*',
        name: 'not-found',
        component: NotFoundView
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const authResult = authGuard(to)
  if (authResult) return authResult

  const adminResult = adminGuard(to)
  if (adminResult) return adminResult
})

export default router
